import {findAll, mergeDeepObject} from "../../../../modules/vegas/js/util";
import Scrollbar from "smooth-scrollbar";

function VGScrollbar($selectors = [], arg = {}) {
	let scrollbars = [];

	if ($selectors.length) {
		scrollbars = $selectors;
	} else {
		scrollbars = findAll('[data-scrollbar]');
	}

	if (scrollbars.length) {
		for (let bar of scrollbars) {
			let option = mergeDeepObject({
				damping: parseInt(bar.dataset.damping) || .1,
				thumbMinSize: parseInt(bar.dataset.thumbMinSize) || 20,
				renderByPixels: bar.dataset.renderByPixels !== 'false',
				alwaysShowTracks: bar.dataset.alwaysShowTracks || false,
			}, arg);

			Scrollbar.init(bar, option);
		}
	}
}

export default VGScrollbar;
